import "./landingpage.css"
import Header from "./Header"
import Hero from "./Hero"
import Features from "./Features"
import FreeTrial from "./FreeTrial"
import Footer from "./Footer"

const LandingPage = () => {
  return (
    <div className="landing-page">
      <Header />
      <main>
        <article>
          <Hero />
          <Features />
          <FreeTrial />
          <Footer />
        </article>
      </main>
    </div>
  )
}

export default LandingPage
